// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__Vx0iJ","footer":"ChangeClinic_footer__1M9kk"};